module.exports = __webpack_public_path__ + "static/media/S1N9-4.817da68d.svg";